import React from 'react';
import {Col, Row ,Typography} from 'antd';
import "./VechainEnergy.css";
const arrowImage= "../../images/btn-arrow-black.svg"
const { Title, Link, Paragraph } = Typography;
const VechainEnergy = ()=>{
return (
<div className="vechain-sec" style={{ backgroundImage: `url("../../images/vechain-bg.png")`}}>
   <div className="container">
        <Row>
            <Col md={24} lg={12} className="vechain-col">
               <img src="../../images/vechain.png" className="w-100 vechain-col-img" alt=""/>
            </Col>
            <Col md={24} lg={12} className="vechain-col col-one">
                <div className="vechain-content">
                <Title level={2} className="sub-heading"><span>Vechain</span> Energy</Title>
                    <Paragraph className="big-text">Vechian.energy brings blockchain technolory to veteran delveloper. Providing established interfaces to new blockchain technology, optionally hiding the complexity casued by blockchainand web3. </Paragraph>
                    <div className="btn-group">
                        <Link className="primary-btn" href="#">Get Started</Link>
                        <Link className="secoundry-btn" href="#">Chat with us <span>{<img src={arrowImage} alt=""/>}</span></Link>
                    </div>
                </div>
            </Col>
         </Row>
         <span className='mobile_rop1'></span>
         <Row>
            <Col md={24} lg={12} className="ord-1 vechain-col col-secound">
                <div className="vechain-content">
                <Title level={2} className="sub-heading"><span>Simple</span> Configuration</Title>
                <Paragraph className="big-text">Whitelist origins or recipents for Sponsorships. Impement yout own logic in your own contract if you need more control</Paragraph>
                    <ul className="simple-list">
                        <li>
                            Whitelist multiple Origins to pay for transaction from specific wallets or internal implementaion (Node-Services, Development-enviroment, its.)
                        </li>
                        <li>
                            Whitelist multlple to pay for all interactions with a contract or wallet 
                        </li>
                        <li>
                            Congigure contract for extended logic to support complex logics (only NFT-Token-Holders, Users with Roles, etc)
                        </li>
                    </ul>
                <div className="btn-group">
                    <Link className="primary-btn" href="#">Get Started</Link>
                    <Link className="secoundry-btn" href="#">Chat with us <span>{<img src={arrowImage} alt=""/>}</span></Link>
                </div>
              </div>
            </Col>
            <Col md={24} lg={12} className="ord-2 vechain-col">
                <img src="../../images/simple.png" className="w-100 vechain-col-img" alt=""/>
            </Col>
         </Row>
         <Row>
            <Col md={24} lg={12} className="vechain-col">
                <img src="../../images/inner.png" className="w-100 vechain-col-img" alt=""/>
            </Col>
            <Col md={24} lg={12} className="vechain-col col-third">
                <div className="vechain-content">
                <Title level={2} className="sub-heading"> Unlock your<span> Inner</span> Developer Hero</Title>
                <Paragraph className="big-text">We want to see the network grow and help you get started by providing VTHO for projects that    improve the ecosystem</Paragraph>
                <div className="btn-group">
                    <Link className="primary-btn" href="#">Get Started</Link>
                    <Link className="secoundry-btn" href="#">Chat with us <span>{<img src={arrowImage} alt=""/>}</span></Link>
                </div>
                </div>
            </Col>
         </Row>
      </div>
    </div>
)
}
export default VechainEnergy;